import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Tooltip } from '@spa/shared/components';
import Exclamation from '@spa/shared/svg/exclamation';
import { Wrapper, Text, LeftTopLine, Left, TextWrapper } from './styles';
import { theme } from '@spa/shared/theme';
import CheckedBullet from '@spa/shared/svg/check-bullet-green';
import { PRICE_LINE_TYPES } from '@spa/shared/constants/priceLine';

const { BILL, INCLUDED, DISCOUNT } = PRICE_LINE_TYPES;

const PriceLine = ({ title, tooltip, description, value, type = BILL, bigger, bold, ...props }) => {
  const { t } = useTranslation();

  return (
    <Wrapper {...props}>
      <Left>
        <LeftTopLine>
          <Text isTitle bigger={bigger}>
            {title}
          </Text>
          {tooltip ? (
            <Tooltip bottom={false}>
              <Exclamation color="#224251" />
              <Text dangerouslySetInnerHTML={{ __html: tooltip }} />
            </Tooltip>
          ) : null}
        </LeftTopLine>
        {description ? <Text className="description">{description}</Text> : null}
      </Left>
      {type === INCLUDED ? (
        <TextWrapper>
          <Text bigger={bigger} bold={bold} type={type}>
            {t('Included')}
          </Text>
          <CheckedBullet fillColor={theme.colors.mountainMeadow} />
        </TextWrapper>
      ) : (
        <Text bigger={bigger} bold={bold} type={type}>
          {type === DISCOUNT ? '- ' : ''}
          {value}
        </Text>
      )}
    </Wrapper>
  );
};

PriceLine.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(PRICE_LINE_TYPES)),
  bigger: PropTypes.bool,
  bold: PropTypes.bool
};

export default PriceLine;
